import { Injectable } from '@angular/core';
import {BaseService} from './base.service';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PriceListService extends BaseService<any> {
  constructor(http: HttpClient) {
    super(http, `${environment.endPointApiThird}/price-list`);
  }
}
